module.exports = __webpack_public_path__ + "img/kongo.46bc366c.svg";